var ConnectionMethod = {
    APPLE: "apple",
    FACEBOOK: "facebook",
    GOOGLE: "google"
};
export default ConnectionMethod;
